import { useEffect, useState, useRef } from 'react'

import * as S from './styles'

function CodeField({ length = 6, responseType, setValue, confirmCode, autoFocus = true }) {
  const [inputValues, setInputValues] = useState(Array(length).fill(''))
  const inputRefs = useRef([])

  useEffect(() => {
    if (inputValues.join('').length === length) {
      setValue(inputValues.join(''))
    }
  }, [inputValues])

  useEffect(() => {
    if (responseType === 'error') {
      handleFocus(0)
    }
  }, [responseType])

  const handleInputChange = (index, text) => {
    const allowedChars = /^[0-9]$/

    const newValues = [...inputValues]
    const arrayText = [...text]
    let updated = false

    arrayText.forEach(value => {
      if (index === length) return

      if (value.match(allowedChars)) {
        newValues[index] = value
        focusNextChar(index)
        updated = true

        index++
      }
    })

    updated && setInputValues(newValues)
  }

  const handleKeyDown = (index, key) => {
    const prevIndex = index - 1
    const nextIndex = index + 1

    const handleBackspace = () => {
      const newValues = [...inputValues]
      newValues[index] = ''
      setInputValues(newValues)

      if (inputValues[index] === '' && inputValues[prevIndex]) {
        newValues[prevIndex] = ''
        focusPrevChar(index)
      }
    }

    const handleArrowLeft = () => {
      if (inputValues[prevIndex]) {
        focusPrevChar(index)
      }
    }

    const handleArrowRight = () => {
      if (inputValues[nextIndex]) {
        focusNextChar(index)
      }
    }

    const handleEnter = () => {
      if (inputValues.join('').length === length) {
        confirmCode()
        setValue('')
        setInputValues(Array(length).fill(''))
        handleFocus(0)
      }
    }

    const keyHandlers = {
      Backspace: handleBackspace,
      ArrowLeft: handleArrowLeft,
      ArrowRight: handleArrowRight,
      ' ': handleArrowRight,
      Enter: handleEnter,
    }

    if (keyHandlers[key]) {
      keyHandlers[key]()
    }
  }

  const handleFocus = (index) => {
    if (inputRefs.current[index]) {
      inputRefs.current[index].select()
    }
  }

  const focusPrevChar = (index) => {
    inputRefs.current[index - 1].focus()
  }

  const focusNextChar = (index) => {
    const nextIndex = index + 1;
    if (nextIndex < length) {
      inputRefs.current[nextIndex].focus();
    }
  }

  const renderFields = () => {
    return inputValues.map((value, index) => (
      <S.Input
        key={index}
        inputMode='numeric'
        maxLength={index === length - 1 ? 1 : null}
        name={`input-${index}`}
        value={value}
        onChange={(e) => handleInputChange(index, e.target.value)}
        onKeyDown={(e) => handleKeyDown(index, e.key)}
        onFocus={() => handleFocus(index)}
        autoFocus={autoFocus && index === 0}
        ref={(el) => {
          if (el) {
            inputRefs.current.push(el)
          }
        }}
        responseType={responseType}
        readOnly={responseType === 'success'}
      />
    ))
  }

  return <>{renderFields()}</>
}

export default CodeField
